import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AbstractRestService } from 'src/app/shared/types/AbstractRestService';
import { HttpService } from '../http.service';
import { AppSettingsService } from '../app-settings.service';
import { UnitCustomerTokenResponse } from '../../shared/models/unit-customer/UnitCustomerTokenResponse.model';

export enum UnitCustomerTokenType {
  CheckDeposits = 'CheckDeposits',
  Activity = 'Activity'
}

export interface GenerateCustomerTokenRequest {
  tokenTypes: UnitCustomerTokenType[];
}

@Injectable({
  providedIn: 'root'
})
export class UnitCustomerTokenDataService extends AbstractRestService<any, any> {
  protected readonly baseEndpoint$ = this.appSettingsService.localEnv ?
  of('https://localhost:44360/api/CustomerToken/') :
  of('CustomerToken/');

  constructor(public http: HttpService, 
    private appSettingsService: AppSettingsService
  ) {
    super(http);
  }

  getCustomerToken(unitCustomerId: string, request: GenerateCustomerTokenRequest): Observable<string> {
    return this.baseEndpoint$.pipe(
      switchMap((base) =>
        this.http.postTyped<UnitCustomerTokenResponse>(
          `${base}${unitCustomerId}/token`,
          request
        )
      ),
      map(response => response.token)
    );
  }
}
